import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import filter from "../../Assets/svg/filter.svg";
import lar from "../../Assets/svg/lar.svg"
import backarrow from "../../Assets/svg/backarrow.svg"
import axios from "axios";
import { getCookie } from "../getcookie.js";
import ReactPaginate from 'react-paginate';
import { Link } from "react-router-dom";

const Mailview = ({ children }) => {

    return (
        <Container fluid style={{ width: '100%', padding: '0px', fontFamily: 'Satoshi' }}>
            <div className="d-flex side4">
            
                <Row sm={12} style={{ "--bs-gutter-x": "0px", margin: '0px', width: '100%', height: '100vh', overflow: 'auto', scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: 'center', }}>
                    <Col>
                        
                        <div className="maincontent3">
                            <div className="px-3 py-3 d-flex flex-column" style={{ backgroundColor: '#F3F6F9', gap: '10px' }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                       <Link to='/mail/list'> <div>
                                            <img src={backarrow} alt="" />
                                        </div></Link>
                                        <div style={{ fontWeight: '700', fontSize: '16px', color: '#212129' }}>
                                            sanju@lenteratech.com
                                        </div>

                                    </div>

                                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                        <button className="px-4 py-2" style={{ border: '0.6px solid #E5E5E5', borderRadius: '100px', backgroundColor: '#FFFFFF', color: '#21272C', fontWeight: '700', fontSize: '14px' }}>
                                            Delete
                                        </button>

                                        <button className="px-4 py-2" style={{ border: '0.6px solid #E5E5E5', borderRadius: '100px', backgroundColor: '#6929E2', color: '#FFFFFF', fontWeight: '700', fontSize: '14px' }}>
                                            Edit
                                        </button>
                                    </div>

                                </div>

                                <div className="px-4 py-4 d-flex flex-column mb-2" style={{ borderRadius: '16px', gap: '24px', backgroundColor: '#FFFFFF' }}>
                                    <div className="d-flex justify-content-between" style={{ borderBottom: '2px dotted #E5E5E5', paddingBottom: '16px' }}>
                                        <div className="d-flex flex-column" style={{ gap: '12px' }}>
                                            <div style={{ fontWeight: '700', fontSize: '18px', color: '#212129' }}>
                                                sanju@lenteratech.com
                                            </div>

                                            <div style={{ fontWeight: '400', fontSize: '13px', color: '#8790A1' }}>
                                                Created on 23 Oct 2024 at 04:30 PM
                                            </div>

                                        </div>

                                        <div>
                                            <select style={{ fontWeight: '500', fontSize: '14px', color: '#212129', backgroundColor: '#F5F5F5', cursor: 'pointer', border: 'none', borderRadius: '10px' }} className="px-2 py-2">
                                                <option value="active">🟢 Active</option>
                                                <option value="inactive">🔴 Inactive</option>
                                            </select>
                                        </div>



                                    </div>

                                    <div style={{ fontWeight: '700', fontSize: '14px', color: '#212129' }}>
                                        Mail details
                                    </div>

                                    <div className="d-flex flex-column col-5" style={{ gap: '20px' }}>
                                        <div className="d-flex col-12" style={{gap:'4px'}} >
                                            <div style={{ fontWeight: '400', tabSize: '13px', color: '#8790A1' }} className="col-6">
                                                Reporter
                                            </div>

                                            <div style={{ fontWeight: '500', tabSize: '14px', color: '#212129' }} className="col-6">
                                                Flyjac Logistics and Transports
                                            </div>

                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <div style={{ fontWeight: '400', tabSize: '13px', color: '#8790A1' }}className="col-6">
                                                Assigned to
                                            </div>

                                            <div style={{ fontWeight: '500', tabSize: '14px', color: '#212129' }}className="col-6">
                                                19 Nov 2024
                                            </div>

                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <div style={{ fontWeight: '400', tabSize: '13px', color: '#8790A1' }}className="col-6">
                                                SMTP Server
                                            </div>

                                            <div style={{ fontWeight: '500', tabSize: '14px', color: '#212129' }}className="col-6">
                                                21 Dec 2024
                                            </div>

                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <div style={{ fontWeight: '400', tabSize: '13px', color: '#8790A1' }}className="col-6">
                                                SMTP Port
                                            </div>

                                            <div style={{ fontWeight: '500', tabSize: '14px', color: '#212129' }}className="col-6">
                                                5 days
                                            </div>

                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <div style={{ fontWeight: '400', tabSize: '13px', color: '#8790A1' }}className="col-6">
                                                Start time
                                            </div>

                                            <div style={{ fontWeight: '500', tabSize: '14px', color: '#212129' }}className="col-6">
                                            23 Feb, 2024 at 05:30 PM
                                            </div>

                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <div style={{ fontWeight: '400', tabSize: '13px', color: '#8790A1' }}className="col-6">
                                            Interval for reading
                                            </div>

                                            <div style={{ fontWeight: '500', tabSize: '14px', color: '#212129' }}className="col-6">
                                                02:30 Hrs
                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div className="px-4 py-4 d-flex flex-column" style={{borderRadius:'16px',gap:'10px',backgroundColor:'#FFFFFF'}}>
                                    <div style={{fontWeight:'700',fontSize:'20px',color:'#212129'}} className="mb-2">
                                        Filter
                                    </div>

                                    <div className="px-3 py-2">
                                        <div style={{borderRadius:'12px',backgroundColor:'#F3F6F9'}} className="d-flex py-2 px-3">
                                            <div className="col-3" style={{fontWeight:'700',fontSize:'13px',color:'#212129'}}>
                                                Type
                                            </div>
                                            <div className="col-3" style={{fontWeight:'700',fontSize:'13px',color:'#212129'}}>
                                                Value
                                            </div>
                                            <div className="col-3" style={{fontWeight:'700',fontSize:'13px',color:'#212129'}}>
                                                Assignee
                                            </div>
                                            <div className="col-3" style={{fontWeight:'700',fontSize:'13px',color:'#212129'}}>
                                                Reporter
                                            </div>

                                        </div>

                                        <div style={{borderBottom:'0.6px solid #FFFFFF',borderBottom:'0.6px solid #E5E5E5'}} className="d-flex py-2 px-3">
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Subject
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Issue
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Sanjay Jayan
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Karthick
                                            </div>

                                        </div>

                                        <div style={{borderBottom:'0.6px solid #FFFFFF',borderBottom:'0.6px solid #E5E5E5'}} className="d-flex py-2 px-3">
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Subject
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Issue
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Sanjay Jayan
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Karthick
                                            </div>

                                        </div>

                                        <div style={{borderBottom:'0.6px solid #FFFFFF',borderBottom:'0.6px solid #E5E5E5'}} className="d-flex py-2 px-3">
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Subject
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Issue
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Sanjay Jayan
                                            </div>
                                            <div className="col-3" style={{fontWeight:'500',fontSize:'13px',color:'#212129'}}>
                                                Karthick
                                            </div>

                                        </div>

                                    </div>

                                </div>



                            </div>



                        </div>
                    </Col>
                </Row>

            </div>
        </Container>

    );
};

export default Mailview;